import { useContext } from "react"
import ToastContext from "../contexts/ToastContext/context"
import { addToast, removeToast } from "../contexts/ToastContext/actions"
import { Infobox } from "../components/Infobox"
import { DateTime } from "luxon"

export const useToast = () => {
  const { dispatch } = useContext(ToastContext)

  const addGlobalToast = (data: Infobox) => {
    dispatch(addToast({
      ...data,
      type: "toast",
      time: data.time ?? 5000,
      timeAdded: DateTime.now().toISO()
    }))
  }

  const removeGlobalToast = (index: number) => {
    dispatch(removeToast(index))
  }

  return {
    addToast: addGlobalToast,
    removeToast: removeGlobalToast
  }
}
